import { EArticleCategory } from 'Pages/Blog/Hooks/Definitions/Article.d';
import { useFetchArticles } from 'Pages/Blog/Hooks/useFetchArticles';
import React from 'react';
import KickImage from 'Reuseables/KickImage';
import ReactPlaceholder from 'react-placeholder/lib';
import { RectShape, TextBlock } from 'react-placeholder/lib/placeholders';
import ListItem from '../../Molecules/ListItem';

import { IListProps } from './List.definitions';

/** CSS import */
import Styles from './List.module.scss';

/**Utils */
import { getCloudImageUrl, emptyImage } from 'utils/Helpers';

const CustomPlaceholder: React.FC = () => {
  return (
    <div className={Styles['placeholder']}>
      {Array.from({ length: 15 }).map((_, index) => (
        <div
          key={`popular-placeholder-${index}`}
          className={Styles['placeholder-item']}
        >
          <RectShape color="#eeeeee" style={{ width: '100%', height: 98 }} />
          <TextBlock rows={2} color="#eeeeee" />
        </div>
      ))}
    </div>
  );
};

const List: React.FC<IListProps> = (props: IListProps) => {
  const { title, items, isReady } = props;

  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['title']}>{title}</p>
      <ReactPlaceholder
        customPlaceholder={<CustomPlaceholder />}
        ready={isReady || items.length > 0}
      >
        {items.map((item) => (
          <ListItem
            key={item.id}
            title={item.title}
            date={item.created_at}
            image={item.thumbnail?.URL ? getCloudImageUrl(item.thumbnail?.URL) : ""}
            slug={item.slug}
          />
        ))}
      </ReactPlaceholder>
    </div>
  );
};

export default List;
